import Repository from "./Repository";
const resource = "/auth/v1/linkPay/reports";
import axios from "axios";
const { getToken } = require("../lib/storage");

export default {
  getAllPaymentModes() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/payment_modes`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  fetchPaymentModeDetail(params) {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/mode_wise`, { params })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getDashBoardResource(params) {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/dashboard`, { params })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getAllTransactionDetails(params) {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}`, { params })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getAllMerchants() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/merchants`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  resendLink(hash, payload) {
    return new Promise((resolve, reject) => {
      Repository.post(`${resource}/resned/${hash}/paymentLink`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getAllLinkStatus() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/link_status`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getAllPaymentStatus() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/payment_status`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getExcelReport(params) {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/excel`, {
        params: { ...params },
        responseType: "blob",
      })
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          const r = JSON.parse(await error.response.data.text());
          reject(r);
        });
    });
  },
  // getExcelReport(params){
  //   let baseEndpoint = ''
  //   if (process.env.NODE_ENV === 'development') {
  //       baseEndpoint = process.env.VUE_APP_BASE_URL_DEV
  //   } else {
  //       baseEndpoint = '/api'
  //   }
  //   return new Promise((resolve, reject) => {
  //     axios.get(`${baseEndpoint}${resource}/excel`,{
  //       method: 'get',
  //       params,
  //       responseType: 'blob',
  //       headers: {
  //         Authorization: `Bearer ${getToken()}`
  //       },
  //   })
  //       .then(response => {
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         reject(error.response);
  //       });
  //   });
  // },
};
